module.exports = __webpack_public_path__ + "static/process-detail-1b.f64485b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/process-details/process-detail-1b.png
// module id = 1488
// module chunks = 214286880276331